<template>
  <div class="end-msg-dialog" v-if="show">
    <div class="dialog-box" @touchmove.prevent>
      <div class="dialog-mask"></div>
      <div class="dialog">
        <div class="dialog-close" @click="closeDialog">
          <i class="el-icon-close"></i>
        </div>
        <div class="dialog-icon">
          <img src="https://www.dellemc-solution.com/static/pc/img/campaign/dtf/layer-wait-pic.png" />
        </div>
        <div class="dialog-content">
          <p class="text-big">活动已下线</p>
          <p class="text-desc">前往戴尔易安心企采商城首页<br/>浏览更多资讯、促销活动</p>
          <span class="text-link">
            <a href="https://www.dellemc-solution.com" target="_blank" class="btn-link">返回官网</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EndMsgDialog',
  props: {
    show: Boolean,
  },
  data() {
    return {}
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
//pc
@media screen and (min-width: 992px) {
  .end-msg-dialog {
    .dialog-box {
      width: 100%;
      height: 100%;
      z-index: 2147483602;
      position: fixed;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      left: 0;
    }
    .dialog-mask {
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.5);
      position: absolute;
      top: 0;
      left: 0;
    }
    .dialog {
      width: 560px;
      min-height: 335px;
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 4px 4px rgba(0,0,0,.2);
      background-color: #ffffff;
      position: relative;

      &:before {
        content: "";
        width: 100%;
        height: 165px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #f5fafd;
      }

      .dialog-close {
        position: absolute;
        top: 15px;
        right: 25px;
        width: 22px;
        height: 22px;
        color: #999;
        font-size: 24px;
        cursor: pointer;
      }

      .dialog-icon {
        margin-bottom: 50px;

        img {
          position: relative;
          display: block;
          margin: 0 auto;
          padding-top: 45px;
          width: 100px;
        }
      }

      .dialog-content {
        font-size: 18px;
        color: #666666;
        padding: 0 0 40px;
        text-align: center;

        .text-big {
          color: #333;
          font-size: 24px;
          height: 50px;
          line-height: 50px;
        }

        .text-desc {
          padding: 0 60px;
        }

        .text-link {
          font-size: 22px;
          padding-top: 10px;
          display: inline-block;

          a {
            color: #007db8;
            text-decoration: underline;

            &:hover {
              color: lighten(#007db8, 20%);
            }
          }
        }
      }
    }
  }
}

//wap
@media screen and (max-width: 992px) {
  .end-msg-dialog {
    .dialog-box {
      width: 100%;
      height: 100%;
      z-index: 2147483602;
      position: fixed;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      left: 0;
    }
    .dialog-mask {
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.5);
      position: absolute;
      top: 0;
      left: 0;
    }
    .dialog {
      width: 80vw;
      border-radius: 3vw;
      overflow: hidden;
      box-shadow: 0 4px 4px rgba(0,0,0,.2);
      background-color: #ffffff;
      position: relative;

      &:before {
        content: "";
        width: 100%;
        height: 44vw;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #f5fafd;
      }

      .dialog-close {
        position: absolute;
        top: 3vw;
        right: 3vw;
        color: #999;
        font-size: 6vw;
        cursor: pointer;
      }

      .dialog-icon {
        margin-bottom: 17vw;

        img {
          position: relative;
          display: block;
          margin: 0 auto;
          padding-top: 10vw;
          width: 24vw;
        }
      }

      .dialog-content {
        font-size: 3.6vw;
        color: #666666;
        padding: 0 0 5vw;
        text-align: center;

        .text-big {
          color: #333;
          font-size: 5vw;
          height: 50px;
          line-height: 50px;
        }

        .text-desc {
          padding: 10px 60px 5px;
        }

        .text-link {
          font-size: 5vw;
          padding-top: 10px;
          display: inline-block;

          a {
            color: #007db8;
            text-decoration: underline;

            &:hover {
              color: lighten(#007db8, 20%);
            }
          }
        }
      }
    }
  }
}

</style>
